import { Link } from "react-router-dom";

import { DESIGN_PARTNER_PATHS } from "./routes";

export function DesignPartnerFooter() {
  return (
    <footer>
      <div className="wrap">
        <div className="foot">
          <div>
            <Link to={DESIGN_PARTNER_PATHS.home} className="brand" style={{ color: "#fff" }}>
              <span className="mark" aria-hidden="true" />
              Zephix
            </Link>
            <p>Governed project execution for growing teams.</p>
          </div>
          <div>
            <h4>Product</h4>
            <Link to={DESIGN_PARTNER_PATHS.howItWorks}>How it works</Link>
            <Link to={DESIGN_PARTNER_PATHS.product}>Product capabilities</Link>
            <Link to={DESIGN_PARTNER_PATHS.roadmap}>Roadmap</Link>
          </div>
          <div>
            <h4>Company</h4>
            <Link to={DESIGN_PARTNER_PATHS.apply}>Design partners</Link>
            <Link to={DESIGN_PARTNER_PATHS.faq}>FAQ</Link>
            <Link to={DESIGN_PARTNER_PATHS.contact}>Contact</Link>
          </div>
          <div>
            <h4>Legal &amp; trust</h4>
            <Link to={DESIGN_PARTNER_PATHS.privacy}>Privacy Policy</Link>
            <Link to={DESIGN_PARTNER_PATHS.terms}>Terms of Use</Link>
            <Link to={DESIGN_PARTNER_PATHS.security}>Security approach</Link>
          </div>
        </div>
        <div className="legal">
          <span>© 2026 Zephix. All rights reserved.</span>
          <span>Built for accountable execution.</span>
        </div>
      </div>
    </footer>
  );
}
